(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[139],{

/***/ 6245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "InvalidTokenError": function() { return /* binding */ n; }
/* harmony export */ });
function e(e){this.message=e}e.prototype=new Error,e.prototype.name="InvalidCharacterError";var r="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||function(r){var t=String(r).replace(/=+$/,"");if(t.length%4==1)throw new e("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,o,a=0,i=0,c="";o=t.charAt(i++);~o&&(n=a%4?64*n+o:o,a++%4)?c+=String.fromCharCode(255&n>>(-2*a&6)):0)o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);return c};function t(e){var t=e.replace(/-/g,"+").replace(/_/g,"/");switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw"Illegal base64url string!"}try{return function(e){return decodeURIComponent(r(e).replace(/(.)/g,(function(e,r){var t=r.charCodeAt(0).toString(16).toUpperCase();return t.length<2&&(t="0"+t),"%"+t})))}(t)}catch(e){return r(t)}}function n(e){this.message=e}function o(e,r){if("string"!=typeof e)throw new n("Invalid token specified");var o=!0===(r=r||{}).header?0:1;try{return JSON.parse(t(e.split(".")[o]))}catch(e){throw new n("Invalid token specified: "+e.message)}}n.prototype=new Error,n.prototype.name="InvalidTokenError";/* harmony default export */ __webpack_exports__["default"] = (o);
//# sourceMappingURL=jwt-decode.esm.js.map


/***/ }),

/***/ 9328:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mvpd",
      function () {
        return __webpack_require__(2289);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zW": function() { return /* binding */ Events; },
  "sn": function() { return /* binding */ PageNames; },
  "c7": function() { return /* binding */ PageTypes; },
  "Vk": function() { return /* binding */ handleAccountPageEvent; },
  "qH": function() { return /* binding */ handleHomePageEvent; },
  "GV": function() { return /* binding */ handleTrackEvent; },
  "jV": function() { return /* binding */ mountDataLayer; },
  "l9": function() { return /* binding */ setPageAnalyticsData; }
});

// UNUSED EXPORTS: EventTypes, generatePageName

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/Cookies.js
var Cookies = __webpack_require__(5501);
// EXTERNAL MODULE: ./lib/analytics/segment/index.ts + 2 modules
var segment = __webpack_require__(4292);
;// CONCATENATED MODULE: ./lib/analytics/index.ts

var initiated = false;
var LCP_TIME = 6000;
var init = function() {
    window.segmentFlushQueue = flushQueue;
    if (initiated) return true;
    initSegment();
    initiated = true;
    window.addEventListener("unload", function() {
        flushQueue();
    });
    return initiated;
};
var handleAnalytics = function(event) {
    (0,segment/* segmentTrackEvent */.R7)(event);
};
var timedOutInit = function() {
    if (initiated) return true;
    setTimeout(function() {
        return init();
    }, LCP_TIME);
    return true;
};

// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(1407);
// EXTERNAL MODULE: ./lib/utils/helper.ts
var helper = __webpack_require__(9981);
// EXTERNAL MODULE: ./lib/utils/getConfig.ts + 1 modules
var getConfig = __webpack_require__(889);
;// CONCATENATED MODULE: ./lib/analytics/trackCalls.ts








var EventTypes;
(function(EventTypes) {
    EventTypes["PAGE"] = "page";
    EventTypes["TRACK"] = "track";
})(EventTypes || (EventTypes = {}));
var Events;
(function(Events) {
    Events["BUTTON_LINK_SELECTED"] = "Button Link Selected";
    Events["SUBMIT"] = "Submit";
    Events["SUBMIT_CODE_LANDING"] = "Submit Code Landing";
    Events["SUBMIT_CODE_STARTED"] = "Submit Code Started";
    Events["SUBMIT_CODE_COMPLETED"] = "Submit Code Completed";
    Events["PROFILE_ACCESS_ACTIVATION_STARTED"] = "Profile Access Activation Started";
    Events["PROFILE_ACCESS_ACTIVATION_COMPLETED"] = "Profile Access Activation Completed";
    Events["PROFILE_ACCESS_ACTIVATION_ERROR"] = "Profile Access Activation Error";
    Events["PROFILE_INITIATED"] = "Profile Initiated";
    Events["PROFILE_PROMPT_LANDING"] = "Profile Prompt Landing";
    Events["PROFILE_SIGN_IN_STARTED"] = "Profile Sign In Started";
    Events["PROFILE_SIGN_UP_STARTED"] = "Profile Sign Up Started";
    Events["PROFILE_SIGN_IN_COMPLETED"] = "Profile Sign In Completed";
    Events["PROFILE_SIGN_UP_COMPLETED"] = "Profile Sign Up Completed";
})(Events || (Events = {}));
var FOX_PREFIX = "delta";
var NATION_PREFIX = "nation";
var SPORT_PREFIX = "nation sport";
var PageNames;
(function(PageNames) {
    PageNames["SUBMIT_CODE_LANDING"] = "submit code landing";
    PageNames["PROFILE_PROMPT_LANDING"] = "profile prompt:landing";
})(PageNames || (PageNames = {}));
var PageTypes;
(function(PageTypes) {
    PageTypes["ACTIVATION_CODE"] = "activation code";
    PageTypes["PROFILE_PROMPT"] = "profile prompt";
})(PageTypes || (PageTypes = {}));
var _obj;
var getClientPrefix = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* Brand.FOX */.H2.FOX, FOX_PREFIX), (0,_define_property/* default */.Z)(_obj, constants/* Brand.SPORTS */.H2.SPORTS, SPORT_PREFIX), (0,_define_property/* default */.Z)(_obj, constants/* Brand.NATION */.H2.NATION, NATION_PREFIX), _obj);
var ACTIVATION_METHOD = "2nd screen";
var APP_PLATFORM = "web";
var FOX = "fox";
var FOX_DOMAIN = "fox.com";
var NATION_DOMAIN = "foxnews.com";
var ANONYMOUS_ID_COOKIE = "lastAnonymousProfileId";
var PAGE_TYPE = "ott";
var PRIMARY_BUSINESS_UNIT = "fng";
var PROFILE_ID_COOKIE = "secondScreenProfileId";
var START_SOURCE = "general";
var APP_CLIENT_PREFIX = getClientPrefix["nation"];
var defaultTraits = {
    appsflyer_id: "",
    dcg_profile_id: "",
    lastAnonymousProfileId: "",
    lastKnownProfileId: "",
    mvpd: "",
    network_entitlement_list: "",
    us_privacy: ""
};
// TODO: Update BRAND and DEVICE for Nation
// const DEVICE = account?.device ?? 'FOX';
var BRAND = FOX;
var DEVICE = "FOX";
var defaultProps = {
    app_name: "nation" || 0,
    app_platform: APP_PLATFORM,
    // TODO: set app version dynamically
    app_version: "1.0.0",
    page_name: ACTIVATION_METHOD,
    page_profile_activation_method: ACTIVATION_METHOD,
    page_start_source: START_SOURCE,
    page_type: PAGE_TYPE,
    primary_business_unit: PRIMARY_BUSINESS_UNIT,
    secondary_business_unit: "nation" || 0
};
var handleTrackEvent = function() {
    for(var _len = arguments.length, events = new Array(_len), _key = 0; _key < _len; _key++){
        events[_key] = arguments[_key];
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = _step.value, eventName = _value.eventName, props = _value.props, context = _value.context, eventType = _value.eventType;
            var ref, ref1;
            var cookies = new Cookies/* default */.Z();
            var ref2;
            var profileId = (ref2 = cookies.get(PROFILE_ID_COOKIE)) !== null && ref2 !== void 0 ? ref2 : "";
            var ref3;
            var codeInfoCookie = (ref3 = cookies.get(constants/* COOKIE_CODE_INFO */.r5)) !== null && ref3 !== void 0 ? ref3 : {};
            var campaignCodes = fetchCampaignCodes();
            // TODO: Find out why campaignCodes are different for different events
            if (eventName === Events.PROFILE_ACCESS_ACTIVATION_COMPLETED) {
                var ref4;
                var compaignCodesCookie = (ref4 = cookies.get(constants/* COOKIE_CAMPAIGN_CODES */.gV)) !== null && ref4 !== void 0 ? ref4 : "";
                campaignCodes = parseCampaignParams(compaignCodesCookie);
            }
            var traits = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultTraits, campaignCodes), {
                dcg_profile_id: profileId,
                lastAnonymousProfileId: getAnonymousId(),
                lastKnownProfileId: profileId
            });
            var ref5;
            var argsPageName = (ref5 = props === null || props === void 0 ? void 0 : props.page_name) !== null && ref5 !== void 0 ? ref5 : null;
            var ref6;
            var currentPageName = (ref6 = (ref = window.DataLayer) === null || ref === void 0 ? void 0 : ref.page_name) !== null && ref6 !== void 0 ? ref6 : null;
            var pageName = argsPageName !== null && argsPageName !== void 0 ? argsPageName : currentPageName;
            var genericPageName = generatePageName({
                pageName: pageName
            });
            var ref7;
            var argsPageType = (ref7 = props === null || props === void 0 ? void 0 : props.page_type) !== null && ref7 !== void 0 ? ref7 : null;
            var ref8;
            var currentPageType = (ref8 = (ref1 = window.DataLayer) === null || ref1 === void 0 ? void 0 : ref1.page_type) !== null && ref8 !== void 0 ? ref8 : null;
            var pageType = argsPageType !== null && argsPageType !== void 0 ? argsPageType : currentPageType;
            var ref9;
            var argsActivationCode = (ref9 = props === null || props === void 0 ? void 0 : props.page_activation_code) !== null && ref9 !== void 0 ? ref9 : null;
            var _code;
            var currentActiovationCode = (_code = codeInfoCookie.code) !== null && _code !== void 0 ? _code : null;
            var activationCode = argsActivationCode !== null && argsActivationCode !== void 0 ? argsActivationCode : currentActiovationCode;
            var newContext = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, context), {
                traits: traits
            });
            var finalProps = (0,helper.cleanObject)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultProps), {
                page_name: genericPageName,
                page_type: pageType,
                page_activation_code: activationCode
            }), props));
            handleAnalytics({
                eventName: eventName,
                props: finalProps,
                eventType: eventType,
                context: newContext
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
var generatePageName = function(param) {
    var pageName = param.pageName;
    return "".concat(APP_CLIENT_PREFIX, ":").concat(APP_PLATFORM, ":").concat(pageName);
};
var handleHomePageEvent = function() {
    handleTrackEvent({
        eventName: Events.PROFILE_ACCESS_ACTIVATION_STARTED
    }, {
        eventName: Events.SUBMIT_CODE_STARTED
    }, {
        eventName: Events.SUBMIT_CODE_LANDING,
        eventType: EventTypes.PAGE
    });
};
var handleAccountPageEvent = function() {
    handleTrackEvent({
        eventName: Events.PROFILE_PROMPT_LANDING,
        eventType: EventTypes.PAGE
    });
};
var getAnonymousId = function() {
    var ref;
    var cookies = new Cookies/* default */.Z();
    var user = (ref = window.analytics) === null || ref === void 0 ? void 0 : ref.user;
    var ref1;
    var lastAnonymousProfileId = (ref1 = cookies.get(ANONYMOUS_ID_COOKIE)) !== null && ref1 !== void 0 ? ref1 : "";
    var networkDomain;
    if (BRAND === FOX) networkDomain = FOX_DOMAIN;
    else networkDomain = NATION_DOMAIN;
    if (lastAnonymousProfileId) {
        cookies.set(ANONYMOUS_ID_COOKIE, lastAnonymousProfileId, {
            domain: networkDomain
        });
        return lastAnonymousProfileId;
    }
    var anonymousId = user ? user().anonymousId() : null;
    // TODO: Finds out why it is here
    cookies.set(ANONYMOUS_ID_COOKIE, anonymousId, {
        domain: networkDomain
    });
    return anonymousId;
};
var mountDataLayer = function() {
    window.DataLayer = {};
};
var setPageAnalyticsData = function(param) {
    var pageName = param.pageName, pageType = param.pageType;
    if (!window.DataLayer) mountDataLayer();
    window.DataLayer.page_name = pageName;
    window.DataLayer.page_type = pageType;
};
var parseCampaignParams = function(queryString) {
    if (!queryString) return {};
    var cleanQueryString = queryString.split("undefinedUnknown")[0];
    var segmentCampaign = "cmpid";
    var propertyNames = {
        cmpid: "campaign_int_tracking_code",
        int_cmp: "campaign_int_name"
    };
    var params = {};
    var ref;
    var cleanCampaignString = (ref = cleanQueryString.match(/^[^&]*/)) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var campaignString = (ref1 = cleanCampaignString[0]) !== null && ref1 !== void 0 ? ref1 : "";
    params[propertyNames[segmentCampaign]] = campaignString;
    var campaignCodes = campaignString.split("::");
    (campaignCodes || []).forEach(function(codes) {
        var keyValuesPair = codes.split("=");
        if (keyValuesPair.length === 2) {
            var ref;
            var key = (ref = keyValuesPair[0]) !== null && ref !== void 0 ? ref : "";
            var ref1;
            var value = (ref1 = keyValuesPair[1]) !== null && ref1 !== void 0 ? ref1 : "";
            var _key;
            var property = (_key = propertyNames[key]) !== null && _key !== void 0 ? _key : "";
            params[property] = value;
        }
    });
    return (0,helper.cleanObject)(params);
};
var fetchCampaignCodes = function() {
    var ref;
    var intCmp = (ref = getParameterByName(constants/* INT_CMP */.vl)) !== null && ref !== void 0 ? ref : null;
    // if (intCmp == null) return null;
    var intOrg = "dcg";
    // TODO: Get brand from
    var intMc = BRAND;
    var ref1;
    var intSrc = (ref1 = getDeviceFromProvidersByKey()) !== null && ref1 !== void 0 ? ref1 : DEVICE;
    var intAdd = intMc + (intSrc ? "_" + intSrc : "") + (intCmp ? "_" + intCmp : "");
    var codes = (0,helper.cleanObject)({
        int_org: intOrg,
        int_mc: intMc !== null && intMc !== void 0 ? intMc : null,
        int_src: intSrc !== null && intSrc !== void 0 ? intSrc : null,
        int_cmp: intCmp !== null && intCmp !== void 0 ? intCmp : null,
        int_add: intAdd !== null && intAdd !== void 0 ? intAdd : null
    });
    codes.campaign_int_tracking_code = formatCampaignString(codes);
    return codes;
};
var getParameterByName = function getParameterByName(name) {
    var match = RegExp("[?&]" + name + "=([^&]*)").exec(window === null || window === void 0 ? void 0 : window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, " "));
};
var formatCampaignString = function(campaignCodes) {
    var campaignKeys = Object.keys(campaignCodes);
    return campaignKeys.reduce(function(acc, key, i) {
        var isLast = i === campaignKeys.length - 1;
        return acc + key + "=" + campaignCodes[key] + (!isLast ? "::" : "");
    }, "");
};
var getDeviceFromProvidersByKey = function() {
    var cookies = new Cookies/* default */.Z();
    var ref;
    var codeInfoCookie = (ref = cookies.get(constants/* COOKIE_CODE_INFO */.r5)) !== null && ref !== void 0 ? ref : "";
    var config = (0,getConfig/* getConfig */.i)();
    var ref1;
    var devices = (ref1 = config === null || config === void 0 ? void 0 : config.devices) !== null && ref1 !== void 0 ? ref1 : [];
    Object.entries(devices).forEach(function(element) {
        var deviceName = element[0];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var providerKeys = element[1]["providers-key"];
        if (providerKeys === codeInfoCookie || deviceName === providerKeys) return element;
    });
    return null;
};


/***/ }),

/***/ 2289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/useCookies.js + 1 modules
var useCookies = __webpack_require__(708);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/jwt-decode/build/jwt-decode.esm.js
var jwt_decode_esm = __webpack_require__(6245);
// EXTERNAL MODULE: ./lib/hooks/index.ts + 8 modules
var hooks = __webpack_require__(9434);
// EXTERNAL MODULE: ./lib/utils/index.ts + 3 modules
var utils = __webpack_require__(739);
// EXTERNAL MODULE: ./lib/utils/helper.ts
var helper = __webpack_require__(9981);
// EXTERNAL MODULE: ./lib/utils/configs.ts
var configs = __webpack_require__(2670);
// EXTERNAL MODULE: ./lib/utils/logReportHelper.ts
var logReportHelper = __webpack_require__(1184);
// EXTERNAL MODULE: ./context/GlobalContextProvider.tsx
var GlobalContextProvider = __webpack_require__(1387);
// EXTERNAL MODULE: ./context/state/reducer.ts + 1 modules
var reducer = __webpack_require__(2807);
// EXTERNAL MODULE: ./components/common/index.tsx + 6 modules
var common = __webpack_require__(2513);
// EXTERNAL MODULE: ./lib/analytics/trackCalls.ts + 1 modules
var trackCalls = __webpack_require__(5537);
// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(1407);
// EXTERNAL MODULE: ./styles/colors.ts
var colors = __webpack_require__(2317);
// EXTERNAL MODULE: ./images/global/clearButton.png
var clearButton = __webpack_require__(7861);
var clearButton_default = /*#__PURE__*/__webpack_require__.n(clearButton);
;// CONCATENATED MODULE: ./pages/mvpd/components/SearchInput/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 3px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  height: 50px;\n  width: calc(100vw - 45px);\n  max-width: 330px;\n  position: relative;\n  margin: 20px auto 0;\n  input:focus {\n    outline: none;\n  }\n  .searchWrap {\n    display: flex;\n    height: inherit;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .search {\n    background: 0 0;\n    border: none;\n    font-family: 'Graphik', sans-serif;\n    width: calc(100% - 60px);\n    height: 30px;\n    margin-right: 40px;\n    line-height: 30px;\n    letter-spacing: 0;\n    font-weight: 400;\n    color: ",
        ";\n    font-size: 14px;\n  }\n\n  .closeWrap {\n    position: absolute;\n    right: 15px;\n    bottom: 10px;\n    .close {\n      display: none;\n      position: absolute;\n      height: 18px;\n      width: 18px;\n      top: 16px;\n      right: 16px;\n      border: none;\n      outline: 0;\n      cursor: pointer;\n    }\n  }\n\n  .searchMag {\n    svg {\n      opacity: 0.5;\n      margin-right: 0.5rem;\n      width: 17px;\n    }\n  }\n\n  .searchPlaceholder {\n    width: 100%;\n    position: absolute;\n    font-family: 'Graphik', sans-serif;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto;\n    pointer-events: none;\n    span {\n      color: ",
        ";\n      font-family: 'Graphik', sans-serif;\n      font-size: 14px;\n      font-weight: 500;\n      height: 30px;\n      letter-spacing: 0;\n      line-height: 30px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var handleSearchProviderInputClick = function() {
    (0,trackCalls/* handleTrackEvent */.GV)({
        eventName: trackCalls/* Events.BUTTON_LINK_SELECTED */.zW.BUTTON_LINK_SELECTED,
        props: {
            page_item_title: ProviderSearchListElementsText.searchAllProvidersInput,
            page_destination_url: window.location.origin + constants/* ROUTE_MVPD */.W3
        }
    });
};
var SearchInput = function(param) {
    var setFilteredList = param.setFilteredList, searchQuery = param.searchQuery, handleChange = param.handleChange, setSearchQuery = param.setSearchQuery, setIsFocusedTrue = param.setIsFocusedTrue, setIsFocusedFalse = param.setIsFocusedFalse, isFocused = param.isFocused;
    var searchInput = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "searchWrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        onChange: function(e) {
                            handleChange(e);
                        },
                        className: "search",
                        type: "text",
                        value: searchQuery,
                        ref: searchInput,
                        onFocus: setIsFocusedTrue,
                        onKeyPress: function(e) {
                            e.key === "Enter" && e.preventDefault();
                        },
                        onClick: handleSearchProviderInputClick
                    }),
                    isFocused && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "closeWrap",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Image */.Ee, {
                            width: 18,
                            height: 18,
                            className: "close",
                            onClick: function() {
                                setIsFocusedFalse();
                                setFilteredList([]);
                                setSearchQuery("");
                            },
                            src: (clearButton_default()),
                            alt: "Close button"
                        })
                    }),
                    !isFocused && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "searchPlaceholder",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "searchMag",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Icons.SearchIcon */.PJ.W1, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: ProviderSearchListElementsText.searchAllProvidersInput
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_SearchInput = (/*#__PURE__*/react.memo(SearchInput));
var Form = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-e8ccefd6-0"
})(_templateObject(), colors/* default.white */.ZP.white, colors/* default.white */.ZP.white);

;// CONCATENATED MODULE: ./pages/mvpd/components/ProviderSearchList/index.tsx

function ProviderSearchList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .providerList {\n    max-width: 330px;\n    margin: 0 auto;\n    padding: 2rem 0 0 1rem;\n    a {\n      cursor: pointer;\n    }\n    li {\n      margin: 0;\n      display: block;\n      width: 100%;\n      max-width: 668px;\n      height: 48px;\n      text-align: left;\n    }\n  }\n\n  .noResults {\n    color: $Alto;\n    font-family: Graphik, sans-serif;\n    font-size: 18px;\n    padding-left: 15px;\n    font-style: italic;\n    font-weight: 400;\n    height: 50px;\n    letter-spacing: -0.29px;\n    line-height: 50px;\n    width: 330px;\n    text-align: left;\n    margin: 0 auto;\n  }\n  .notFoundContainer {\n    margin-bottom: 20px;\n    font-size: 14px;\n    font-weight: 400;\n    height: 20px;\n    letter-spacing: 0;\n    line-height: 20px;\n    text-align: center;\n    width: 100%;\n    position: relative;\n    display: flex;\n    justify-content: center;\n    color: $white;\n    font-family: Graphik, sans-serif;\n    .notFoundLink {\n      color: $white;\n      text-decoration: none;\n      opacity: 0.7;\n    }\n  }\n"
    ]);
    ProviderSearchList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var ProviderSearchListElementsText;
(function(ProviderSearchListElementsText) {
    ProviderSearchListElementsText["searchAllProvidersInput"] = "Search All Providers";
    ProviderSearchListElementsText["dontHaveProviderLink"] = "I don't have a TV Provider";
    ProviderSearchListElementsText["noProvidersFoundText"] = "No providers found";
})(ProviderSearchListElementsText || (ProviderSearchListElementsText = {}));
var LINKS = {
    goWatchLink: "nation" === constants/* Brand.SPORTS */.H2.SPORTS ? "https://www.foxsports.com/gowatch" : "https://gowatchfox.com"
};
var ProviderSearchList = function(param) {
    var _mvpdList = param.mvpdList, mvpdList = _mvpdList === void 0 ? [] : _mvpdList, handleMVPDSelect = param.handleMVPDSelect;
    var ref = (0,react.useState)(null), filteredList = ref[0], setFilteredList = ref[1];
    var ref1 = (0,react.useState)(""), searchQuery = ref1[0], setSearchQuery = ref1[1];
    var ref2 = (0,hooks/* useBoolean */.kt)(false), isFocused = ref2.value, setIsFocusedTrue = ref2.setTrue, setIsFocusedFalse = ref2.setFalse;
    var handleChange = function(e) {
        e.preventDefault();
        setSearchQuery(e.target.value);
        var filteredMvpds = mvpdList === null || mvpdList === void 0 ? void 0 : mvpdList.filter(function(mvpd) {
            return mvpd.name.toLowerCase().search(e.target.value.toLowerCase()) !== -1;
        });
        setFilteredList(filteredMvpds);
    };
    var handleDontHaveProviderClick = function() {
        (0,trackCalls/* handleTrackEvent */.GV)({
            eventName: trackCalls/* Events.BUTTON_LINK_SELECTED */.zW.BUTTON_LINK_SELECTED,
            props: {
                page_item_title: ProviderSearchListElementsText.dontHaveProviderLink,
                page_destination_url: LINKS.goWatchLink
            }
        });
    };
    if (!(mvpdList === null || mvpdList === void 0 ? void 0 : mvpdList.length)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Search, {
        children: mvpdList && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SearchInput, {
                    searchQuery: searchQuery,
                    setFilteredList: setFilteredList,
                    setSearchQuery: setSearchQuery,
                    handleChange: handleChange,
                    setIsFocusedTrue: setIsFocusedTrue,
                    setIsFocusedFalse: setIsFocusedFalse,
                    isFocused: isFocused
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "providerList",
                    children: isFocused && (filteredList === null || filteredList === void 0 ? void 0 : filteredList.map(function(mvpd) {
                        var id = mvpd.id, adobePassId = mvpd.adobePassId, name = mvpd.name;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            "data-adobepassid": adobePassId,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                onClick: function() {
                                    return handleMVPDSelect(adobePassId);
                                },
                                children: name
                            })
                        }, id);
                    }))
                }),
                isFocused && (filteredList === null || filteredList === void 0 ? void 0 : filteredList.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "noResults",
                    children: ProviderSearchListElementsText.noProvidersFoundText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "notFoundContainer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "notFoundLink",
                        href: LINKS.goWatchLink,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: handleDontHaveProviderClick,
                        children: ProviderSearchListElementsText.dontHaveProviderLink
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_ProviderSearchList = (/*#__PURE__*/react.memo(ProviderSearchList));
var Search = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-efb164cc-0"
})(ProviderSearchList_templateObject());

// EXTERNAL MODULE: ./styles/helper.ts + 1 modules
var styles_helper = __webpack_require__(9900);
// EXTERNAL MODULE: ./components/common/Loader/index.tsx
var Loader = __webpack_require__(2304);
// EXTERNAL MODULE: ./styles/animations.ts
var animations = __webpack_require__(3167);
// EXTERNAL MODULE: ./components/common/Image/index.tsx
var Image = __webpack_require__(313);
// EXTERNAL MODULE: ./components/common/Link/index.tsx
var Link = __webpack_require__(6754);
;// CONCATENATED MODULE: ./pages/mvpd/components/ProviderButton/index.tsx

function ProviderButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 100px;\n    max-height: 100px;\n  "
    ]);
    ProviderButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-width: calc(100% - 85px);\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  width: 100%;\n  height: 80px;\n  max-height: 80px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  margin: 0;\n  transition: all ease 300ms;\n  cursor: pointer;\n  ",
        "\n  img {\n    width: 100%;\n    max-width: calc((100vw - 10px - 60px) / 4);\n    ",
        "\n  }\n  &:hover {\n    transform: scale(1.05);\n    transition: all ease 300ms;\n  }\n  &:not(:hover):not(:active) {\n    border: 1px solid ",
        ";\n    background: ",
        ";\n    border-radius: 3px;\n  }\n  &:hover:not(.inactive),\n  &:active:not(.inactive) {\n    background-color: ",
        ";\n    color: ",
        ";\n    border: none;\n    img {\n      filter: grayscale(1) invert(1);\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  img {\n    object-fit: contain;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








var ProviderButton = function(param) {
    var provider = param.provider, url = param.url, handleMVPDSelect = param.handleMVPDSelect, _link = param.link, link = _link === void 0 ? "" : _link;
    var parser = document.createElement("a");
    parser.href = url;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
        onClick: handleMVPDSelect,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            passHref: true,
            href: link,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: url,
                    alt: provider,
                    width: 85,
                    height: 30,
                    quality: 65,
                    className: "image",
                    priority: true
                })
            })
        })
    });
};
/* harmony default export */ var components_ProviderButton = (ProviderButton);
var Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-23289e6a-0"
})(_templateObject2(), styles_helper/* respondTo.bp_767 */.s.bp_767(ProviderButton_templateObject()), styles_helper/* respondTo.bp_767 */.s.bp_767(_templateObject1()), colors/* fox.white10 */.vn.white10, colors/* fox.white05 */.vn.white05, colors/* default.white */.ZP.white, colors/* default.black */.ZP.black);
var ImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-23289e6a-1"
})(_templateObject3(), animations/* fadein */.jF);

;// CONCATENATED MODULE: ./pages/mvpd/components/TopProviders/index.tsx

function TopProviders_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-template: 100px / 160px;\n    width: 670px;\n    grid-template: repeat(2, 100px) / repeat(4, 1fr);\n  "
    ]);
    TopProviders_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TopProviders_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      grid-template: 100px / 160px;\n    "
    ]);
    TopProviders_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TopProviders_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: grid;\n  width: 100%;\n  margin-bottom: 0;\n  gap: 10px;\n  grid-template: repeat(4, minMax(0, 80px)) / repeat(2, 1fr);\n  ",
        "\n  &.returning-provider-logo {\n    align-content: center;\n    justify-content: center;\n    margin-bottom: 40px;\n    grid-template: 80px / 150px;\n    ",
        "\n  }\n  &.isSingle {\n    grid-template: 1fr / 1fr;\n    width: 160px;\n  }\n"
    ]);
    TopProviders_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var TopProviders = function(param) {
    var _topProviders = param.topProviders, topProviders = _topProviders === void 0 ? [] : _topProviders, handleMVPDSelect = param.handleMVPDSelect;
    if (!topProviders.length) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {
        abCenter: true
    });
    var className;
    if (topProviders.length === 1) {
        className = "isSingle";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid, {
        role: "presentation",
        "data-testid": "custom-element",
        className: className,
        children: topProviders === null || topProviders === void 0 ? void 0 : topProviders.map(function(item) {
            var ref;
            var logos = item.logos, provider = item.provider, id = item.id, adobePassId = item.adobePassId;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProviderButton, {
                handleMVPDSelect: function() {
                    return handleMVPDSelect(adobePassId);
                },
                provider: provider,
                url: (logos === null || logos === void 0 ? void 0 : (ref = logos[1]) === null || ref === void 0 ? void 0 : ref.url) || ""
            }, id);
        })
    });
};
/* harmony default export */ var components_TopProviders = (TopProviders);
var Grid = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-fa9ddcff-0"
})(TopProviders_templateObject2(), styles_helper/* respondTo.bp_768 */.s.bp_768(TopProviders_templateObject()), styles_helper/* respondTo.bp_768 */.s.bp_768(TopProviders_templateObject1()));

;// CONCATENATED MODULE: ./pages/mvpd/index.page.tsx





function index_page_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  ",
        ";\n"
    ]);
    index_page_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


















var MVPDPage = function(param) {
    var profile = param.profile;
    var ref;
    var ref1 = (0,react.useContext)(GlobalContextProvider/* AppContext */.I), dispatch = ref1.dispatch, account = ref1.state.account;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useCookies/* default */.Z)([
        constants/* ACCOUNT_COOKIE_NAME_FOX */.EO,
        constants/* COOKIE_CODE_INFO */.r5
    ]), 1), cookies = ref2[0];
    var router = (0,next_router.useRouter)();
    var ref3 = (0,react.useState)([]), mvpdList = ref3[0], setMvpdList = ref3[1];
    var selectedMvpdId = (ref = cookies[constants/* COOKIE_CODE_INFO */.r5]) === null || ref === void 0 ? void 0 : ref.selectedMvpdId;
    var selectedProvider = [];
    if (selectedMvpdId !== "") {
        var ref4;
        selectedProvider = (ref4 = mvpdList === null || mvpdList === void 0 ? void 0 : mvpdList.filter(function(mvpd) {
            return mvpd.code === selectedMvpdId || mvpd.adobePassId === selectedMvpdId;
        })) !== null && ref4 !== void 0 ? ref4 : [];
    }
    var showAll = (selectedProvider === null || selectedProvider === void 0 ? void 0 : selectedProvider.length) === 0;
    var topEight = mvpdList === null || mvpdList === void 0 ? void 0 : mvpdList.slice(0, 8);
    var topProviders = showAll ? topEight : selectedProvider;
    var ref5 = (0,hooks/* useFlowManager */.ix)(), isNoCodeOrAccount = ref5.isNoCodeOrAccount, isAnonymous = ref5.isAnonymous, isNation = ref5.isNation;
    (0,react.useEffect)(function() {
        router === null || router === void 0 ? void 0 : router.prefetch(constants/* ROUTE_HOME */.XX);
    }, [
        router
    ]);
    (0,react.useEffect)(function() {
        if (isNoCodeOrAccount) {
            router === null || router === void 0 ? void 0 : router.push(constants/* ROUTE_HOME */.XX);
        }
    }, [
        cookies,
        isNoCodeOrAccount,
        router
    ]);
    (0,react.useEffect)(function() {
        if (!(profile === null || profile === void 0 ? void 0 : profile.getMvpds)) return;
        var fetchMvpds = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(val) {
                var ref, response, _tmp, member, error, responseError, _tmp1;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                (0,utils/* refreshToken */.g$)(profile, account)
                            ];
                        case 1:
                            _state.sent();
                            _tmp = {};
                            return [
                                4,
                                profile === null || profile === void 0 ? void 0 : (ref = profile.getMvpds) === null || ref === void 0 ? void 0 : ref.call(profile, (_tmp.itemsPerPage = val, _tmp))
                            ];
                        case 2:
                            response = _state.sent();
                            member = response.member;
                            setMvpdList(member === null || member === void 0 ? void 0 : member.filter(function(mvpd) {
                                return mvpd.adobePassId !== constants/* PREVIEW_PASS_5_MVPD */.ME && mvpd.adobePassId !== constants/* PREVIEW_PASS_60_MVPD */.hn;
                            }));
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            responseError = "Account RegCode Error";
                            _tmp1 = {};
                            (0,logReportHelper/* logError */.H)(error, (_tmp1.name = responseError, _tmp1));
                            return [
                                2,
                                error
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchMvpds(val) {
                return _ref.apply(this, arguments);
            };
        }();
        fetchMvpds(999);
        dispatch((0,reducer/* setFlowStage */.Kc)(constants/* FLOW_STAGE_MVPD_SELECT */.Vr));
        return function() {
            setMvpdList([]);
        };
    }, [
        dispatch,
        profile,
        account
    ]);
    var handleMVPDSelect = function(adobePassId) {
        var ref;
        var updatedProfile;
        var getMvpdLink = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(adobePassId, regCode) {
                var newAuthData, newAccessToken, ref, ref1, _tmp, getTokenTTL, redirectUrl, ref2, response, _tmp1, _tmp2, authenticateUrl, error, responseError, _tmp3;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!adobePassId) return [
                                2
                            ];
                            return [
                                4,
                                (0,utils/* refreshToken */.g$)(profile, account)
                            ];
                        case 1:
                            newAuthData = _state.sent();
                            newAccessToken = newAuthData === null || newAuthData === void 0 ? void 0 : newAuthData.accessToken;
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                7,
                                ,
                                9
                            ]);
                            _tmp = {};
                            return [
                                4,
                                (0,helper.setConfigToProfile)(profile, (_tmp.appName = configs/* profileConfig.appName */.Vc.appName, _tmp.appVersion = configs/* profileConfig.appVersion */.Vc.appVersion, _tmp.accessToken = isAnonymous && newAccessToken ? newAccessToken : (ref = cookies[constants/* ACCOUNT_COOKIE_NAME_FOX */.EO]) === null || ref === void 0 ? void 0 : ref.accessToken, _tmp))
                            ];
                        case 3:
                            updatedProfile = _state.sent();
                            getTokenTTL = (0,jwt_decode_esm["default"])((ref1 = cookies[constants/* ACCOUNT_COOKIE_NAME_FOX */.EO]) === null || ref1 === void 0 ? void 0 : ref1.accessToken);
                            redirectUrl = "".concat(window.location.origin).concat(constants/* ROUTE_SUCCESS */.VU, "?regCode=").concat(regCode);
                            if (!(0,helper.tokenValid)(getTokenTTL)) return [
                                3,
                                6
                            ];
                            _tmp1 = {};
                            _tmp2 = {};
                            return [
                                4,
                                updatedProfile === null || updatedProfile === void 0 ? void 0 : (ref2 = updatedProfile.mvpdLogin) === null || ref2 === void 0 ? void 0 : ref2.call(updatedProfile, (0,_object_spread/* default */.Z)((_tmp1.regCode = regCode, _tmp1.mvpdId = adobePassId, _tmp1.redirectUrl = redirectUrl, _tmp1), !isNation && (_tmp2.additionalHeaders = {
                                    "X-Delegated-Auth-Flow-Off": true
                                }, _tmp2)))
                            ];
                        case 4:
                            response = _state.sent();
                            dispatch((0,reducer/* setFlowStage */.Kc)(constants/* FLOW_STAGE_MVPD_AUTH */.xg));
                            authenticateUrl = response.authenticateUrl;
                            return [
                                4,
                                router.push("".concat(authenticateUrl))
                            ];
                        case 5:
                            _state.sent();
                            _state.label = 6;
                        case 6:
                            return [
                                3,
                                9
                            ];
                        case 7:
                            error = _state.sent();
                            responseError = "Error Updating Profile Account";
                            _tmp3 = {};
                            (0,logReportHelper/* logError */.H)(error, (_tmp3.name = responseError, _tmp3));
                            return [
                                4,
                                router.push(constants/* ROUTE_HOME */.XX)
                            ];
                        case 8:
                            _state.sent();
                            return [
                                3,
                                9
                            ];
                        case 9:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getMvpdLink(adobePassId, regCode) {
                return _ref.apply(this, arguments);
            };
        }();
        getMvpdLink(adobePassId, (ref = cookies[constants/* COOKIE_CODE_INFO */.r5]) === null || ref === void 0 ? void 0 : ref.code);
    };
    if (isNoCodeOrAccount || !mvpdList || !topProviders) return /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Loader */.aN, {
        abCenter: true
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* SEO */.HJ, {
                title: "MVPD"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MVPD, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Messages */.Vm, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TopProviders, {
                        topProviders: topProviders,
                        handleMVPDSelect: handleMVPDSelect
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProviderSearchList, {
                        mvpdList: mvpdList,
                        handleMVPDSelect: handleMVPDSelect
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var index_page = (MVPDPage);
var MVPD = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-28b754b4-0"
})(index_page_templateObject(), animations/* fadein */.jF);


/***/ }),

/***/ 1163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(387)


/***/ }),

/***/ 7861:
/***/ (function(module) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAEqADAAQAAAABAAAAEgAAAACaqbJVAAABMUlEQVQ4Ea2US27CQBBE7ZBkxTU4Btk4F+AfZQESyqmsbLKJBKfwMTgFG1gBwrwaZmDccQKWUlKpP9Nd0y0zJEkNyrLMYA5XcOMpX7mspqWaoqgDC3gLqulUu33EQReubylE56rtVsRIaJImIkFPPdfJCO5ZJzRbW7ipyL7aE+I3OIM7GHDA+YA6s8geUBtX9jwH7TRNv3AncA8P8J3cJ/YZWkwSpPVZLXS7uwA7gCN1YnswnpLQYaVD/U7qsCfpBLxIn7hORL0brfYXjtFhCz+N4tgtf1tNN/dUiR3CvvfH+Frbwq2W2yzxLGrUirGwvpxFrtWWajJQ45zcN3yET3BBbordQouFS1BQ2CsaxMVFlab/eSJSROwFNnlvPx9tGM1Pds+aqrk+1iBgLUWN/9hOkyZGRsghSyUAAAAASUVORK5CYII="

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [130,513,774,888,179], function() { return __webpack_exec__(9328); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);